<template>
  <div class="missions bp-page">
    <template v-if="show_page">
      <PageHeader />
      <div class="bp-page__content">
        <MissionsChallenge />
        <MissionsList />
      </div>
    </template>
  </div>
</template>
<script>
import "@/assets/missions/styles/missions.styl";
import MissionsChallenge from "./blocks/MissionsChallenge";
import MissionsList from "./blocks/MissionsList";
import PageHeader from "@/components/Common/PageHeader";

export default {
  name: "Missions",

  components: {
    MissionsChallenge,
    MissionsList,
    PageHeader,
  },

  data() {
    return {
      show_page: false,
    };
  },

  mounted() {
    this.$store.dispatch("missions/getUserDailyTask").then(() => {
      this.show_page = true;
    });
  },
};
</script>
